<script setup lang="ts">
import { updateElementalAsAdmin } from '~~/src/api/elementals'
import type { Elemental, ElementalType } from '~~/src/types/elemental'

interface IProps {
  elemental?: Elemental
  elementalType?: ElementalType | null
}
const props = defineProps<IProps>()
const { elemental, elementalType } = toRefs(props)

const user = useUser()
const adminTools = useAdminTools()

const isError = ref<null | boolean>(null)
const handleUpdate = async (values: { isHidden?: boolean; isFeatured?: boolean; companiesSection?: boolean }) => {
  if (!elemental?.value || !elementalType?.value?.name)
    return

  isError.value = null
  isError.value = !!(await updateElementalAsAdmin(elementalType.value.url, elemental.value.id, values))

  window.location.reload()
}
</script>

<template>
  <div v-if="user?.isAdmin && adminTools" flex flex-col gap-2>
    <PopupMenu v-if="user?.isAdmin && adminTools">
      <AppButton
        variant="outline"
        class="!p-3" h="42px"
        title="Toggle Admin Menu"
      >
        <div i-material-symbols-more-horiz color-amber />
      </AppButton>

      <template #content>
        <AppFloatingMenu>
          <ul>
            <NuxtLink v-if="elemental" :to="`/${elementalType ? elementalType.name : 'prompt'}/${elemental.url || elemental.id}/edit`">
              <AppFloatingMenuItem color-admin cursor-pointer>
                Edit
              </AppFloatingMenuItem>
            </NuxtLink>
            <AppFloatingMenuItem color-admin cursor-pointer @click="(handleUpdate({ isHidden: false }))">
              Unhide
            </AppFloatingMenuItem>
            <AppFloatingMenuItem color-admin cursor-pointer @click="(handleUpdate({ isHidden: true }))">
              Hide
            </AppFloatingMenuItem>
            <AppFloatingMenuItem color-admin cursor-pointer @click="(handleUpdate({ isFeatured: false }))">
              Unfeature
            </AppFloatingMenuItem>
            <AppFloatingMenuItem color-admin cursor-pointer @click="(handleUpdate({ isFeatured: true }))">
              Feature
            </AppFloatingMenuItem>
            <AppFloatingMenuItem color-admin cursor-pointer @click="(handleUpdate({ companiesSection: true }))">
              Add Company Section
            </AppFloatingMenuItem>
            <AppFloatingMenuItem color-admin cursor-pointer @click="(handleUpdate({ companiesSection: false }))">
              Remove Company Section
            </AppFloatingMenuItem>
          </ul>
        </AppFloatingMenu>
      </template>
    </PopupMenu>

    <TextV2 v-if="isError !== null" :class="isError ? 'color-bluishDark' : 'color-orange'">
      {{ isError ? 'Admin request succeeded' : 'Admin request failed' }}
    </TextV2>
  </div>
</template>
